import { render, staticRenderFns } from "./StatsCard.vue?vue&type=template&id=1ed958d0&scoped=true"
import script from "./StatsCard.vue?vue&type=script&lang=js"
export * from "./StatsCard.vue?vue&type=script&lang=js"
import style0 from "./StatsCard.vue?vue&type=style&index=0&id=1ed958d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed958d0",
  null
  
)

export default component.exports